import { Button, Col, Input, Row } from "antd";
import TableClientsPaged from "./table_clients_paged";
import { useClientsPaged } from "../../../../hooks/order_list_views/useClientsPaged.hook";

export default function InfoClients(){

    const hook = useClientsPaged();
    
    return(
        <Row>
            <Col lg={24} xs={24}>
                <div style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
                    <div style={{ width: '50%', display: 'flex', flexDirection: 'column' }}>
                    <span>Clientes</span>
                    </div>
                    <div style={{ width: '50%', display: 'flex', flexDirection: 'row-reverse' }}>
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <div style={{ marginRight: '10px', height: '100%', display: 'flex', alignItems: 'center'}}>Cliente: </div>
                            <Input 
                                style={{ marginRight: '10px' }}
                                value={hook.nameFilter ?? ''}
                                onChange={(e) => {
                                    hook.setNameFilter(e.target.value);
                                }}
                            />
                            <Button
                                type="primary"
                                onClick={() => {
                                    hook.setPage(0);
                                    hook.loadData(0, hook.count);
                                }}
                            >
                                Buscar
                            </Button>
                        </div>
                    </div>
                </div>
            </Col>
            <TableClientsPaged
                hook={hook}
            />
        </Row>
    );
}